module.exports = __webpack_public_path__ + "static/img/海报设计-插画海报.d3b61b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/海报设计-插画海报.png
// module id = +pel
// module chunks = 1